import { create } from 'zustand';

import { GlobalErrorType } from '@/shared/types/GlobalError';

type GlobalErrorStore = {
  errorType: GlobalErrorType | null;
};

type GlobalErrorStoreActions = {
  resetGlobalError: () => void;
  setGlobalError: (error: { errorType: GlobalErrorType }) => void;
};

const initialState: GlobalErrorStore = {
  errorType: null,
};

export const useGlobalErrorsStore = create<GlobalErrorStore & GlobalErrorStoreActions>((set) => ({
  ...initialState,
  resetGlobalError: () => set({ errorType: null }),
  setGlobalError: ({ errorType }) => set({ errorType }),
}));
